import React from 'react';
import { SkeletonProps } from '../../interfaces/SkeletonProps';
import Refresh from '../Refresh/Refresh';
import PlaceholderBar from '../PlaceholderBar/PlaceholderBar';
import { useTranslation } from 'react-i18next';

const TotalsSkeleton: React.FunctionComponent<SkeletonProps> = ({
  animated,
  displayRefreshButton,
  onRefresh,
}) => {
  const { t } = useTranslation('common', { useSuspense: false });

  return (
    <Refresh
      className="jg-display-flex jg-flex-column jg-flex-aic"
      displayRefreshButton={displayRefreshButton}
      onRefresh={onRefresh}
      buttonLabel={t('page.totaliser_refresh')}
    >
      <PlaceholderBar width="30%" height={36} animated={animated} />
      <PlaceholderBar width="60%" height={19} animated={animated} />
    </Refresh>
  );
};

export default TotalsSkeleton;
